import {
  CommonParamsType,
  CommonSuccessResponse,
} from "constants/types/common";
import { RegionResponse } from "constants/types/region";
import { useMemo } from "react";
import useSWR from "swr";
import { serialize } from "utils/validation/string";

export const getRegionListKey = (params?: CommonParamsType) => {
  return `/region?${serialize({ ...params })}`;
};

export const useRegions = (params?: CommonParamsType) => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<RegionResponse[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(getRegionListKey(params), { refreshInterval: 0 });

  const pagination = data?.meta;
  const regions = data?.data;

  return {
    regions,
    pagination,
    error,
    isLoading,
    mutate,
  };
};

export const useListRegion = () => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<RegionResponse[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR("/region/all", {
    refreshInterval: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const regionList = data?.data ?? [];

  const regionOptions = useMemo(
    () =>
      regionList.map((region) => ({
        label: region.name,
        value: region.id,
      })),
    [regionList],
  );

  return {
    regionList,
    regionOptions,
    error,
    isLoading,
    mutate,
  };
};
